import React from 'react';
import { FormattedMessage } from 'react-intl';

import { YesNoChoice } from 'types/Question';

import Button, { ButtonSize, ButtonType } from '../Button';

interface YesNoCardActionsProps {
  value?: YesNoChoice;
  onChange?: (value: YesNoChoice) => void;
}

const YesNoCardActions: React.FC<YesNoCardActionsProps> = ({ value, onChange }) => {
  const handleOnAccept = React.useCallback(() => onChange?.(YesNoChoice.YES), [onChange]);
  const handleOnRefuse = React.useCallback(() => onChange?.(YesNoChoice.NO), [onChange]);

  return (
    <div className="relative grid grid-cols-2">
      <Button
        testId="refuse"
        size={ButtonSize.SMALL}
        onClick={handleOnRefuse}
        className="mr-1.5 !py-0 h-btn"
        type={value === YesNoChoice.NO ? ButtonType.TERTIARY : ButtonType.PRIMARY}
      >
        <FormattedMessage id="confirm.no" defaultMessage="No" />
      </Button>
      <Button
        testId="accept"
        size={ButtonSize.SMALL}
        onClick={handleOnAccept}
        className="ml-1.5 !py-0 h-btn"
        type={value === YesNoChoice.YES ? ButtonType.TERTIARY : ButtonType.PRIMARY}
      >
        <FormattedMessage id="confirm.yes" defaultMessage="Yes" />
      </Button>
    </div>
  );
};

export default YesNoCardActions;
